import { ModuleFE_Advisor_FHIRQuery } from '../../../../modules/static-modules/fhir.js';
import { ModuleFE_BaseSandboxModule } from '../ModuleFE_BaseSandboxModule.js';
export class Module_SandboxFHIRQuery_Class extends ModuleFE_BaseSandboxModule {
    constructor() {
        super('storage-FHIR', []);
    }
    async listTemplates() {
        return [
            ...ModuleFE_Advisor_FHIRQuery.cache.map(item => ({
                label: item.label,
                content: item
            }))
        ];
    }
    async sendRequest(template, content) {
    }
}
export const ModuleFE_SandboxFHIRQuery = new Module_SandboxFHIRQuery_Class();
//# sourceMappingURL=ModuleFE_SandboxFHIRQuery.js.map